module.exports = __webpack_public_path__ + "static/media/UG.056a6f62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/UG.svg
// module id = 383
// module chunks = 0